<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="middle"
  >
    <template #header>
      <div>
        Feedback详情
        <template v-if="row.status === 'Pending'">
          <gj-tag color="#1F6EEF">待处理</gj-tag>
        </template>
        <template v-else-if="row.status === 'Processing'">
          <gj-tag color="#34bfa3">处理中</gj-tag>
        </template>
        <template v-else-if="row.status === 'Done'">
          <gj-tag color="#5bbd2a">已完成</gj-tag>
        </template>
        <span class="size12 color999" style="margin-left: 16px;">同一订单编号若NR邮件任务已存在，则不会生成NF邮件任务</span>
      </div>
    </template>
    <template #content>
      <div class="content">
        <el-row>
          <el-col :span="12">
            <label class="label">店铺/国家</label>
            <label class="value">{{ row.marketId | optionText(marketOption) | defaultShow }}</label>
          </el-col>
          <el-col :span="12">
            <label class="label">订单编号</label>
            <label class="value">{{ row.orderId | defaultShow }}</label>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <label class="label">评论日期</label>
              <label class="value">{{ row.feedbackDateStr | defaultShow }}</label>
            </el-row>
          </el-col>
          <el-col :span="12">
            <div style="display: flex">
              <label class="label">星级</label>
              <label>
                <gj-rate disabled :value="row.rating"></gj-rate>
              </label>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <label class="label">记录时间</label>
              <label class="value">{{ row.createTime | defaultShow }}</label>
            </el-row>
          </el-col>
          <el-col :span="12">
            <div style="display: flex">
              <label class="label">最终星级</label>
              <label class="value">
                <gj-rate disabled :value="row.lastStar"></gj-rate>
              </label>
            </div>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <label class="label">买家邮箱</label>
              <label class="value">{{ row.buyerEmail | defaultShow }}</label>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <label class="label">跟踪结果</label>
              <label class="value">{{ lastResult }}</label>
            </el-row>
          </el-col>

        </el-row>
        <el-row style="display: flex">
          <div class="label">评论内容</div>
          <div class="value">{{ row.comments | defaultShow }}</div>
        </el-row>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "../../../../minxins";
import {mapGetters} from "vuex";
import {trackingResultsOption} from "@/utils/options";

export default {
  name: "feedback-detail",
  mixins: [modalMixIn],
  props: {
    row: {
      type: Object,
      require: true,
    }
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    lastResult: function () {
      return trackingResultsOption.find(r => r.id === this.row.lastResult)?.text||'-'
    }
  }

}
</script>

<style scoped>
.label {
  color: #666;
  margin-right: 12px;
  min-width: 58px;
  display: inline-block;
  text-align: right;
  font-size: 12px;
}

.value {
  color: #333;
  font-size: 12px;
}

.content {
  height: 350px;
}

.content > div {
  margin-bottom: 15px;
}
</style>
